import React from 'react'

interface RoleSettingsSectionProps {
  title: string
  description: string
  className?: string
  summary?: React.ReactNode
  children: React.ReactNode
}

export const RoleSettingsSection = ({
  title,
  description,
  className,
  summary,
  children,
}: RoleSettingsSectionProps) => (
  <section
    className={`role-settings-section${className ? ` ${className}` : ''}`}
    aria-label={title}
  >
    <header className="role-section-header">
      <div className="role-section-copy">
        <h2>{title}</h2>
        <p className="role-section-description">{description}</p>
      </div>
      {summary && <span className="role-section-summary">{summary}</span>}
    </header>
    {children}
  </section>
)
